import RateAnswers, { PATH as AGA } from './RateAnswers'
import NickName, { PATH as NICKNAME } from './NickName'
import AGALoading, { PATH as LOADING } from './Loading'
import AGAResult, { PATH as RESULT } from './Result'

export default { RateAnswers, NickName, AGALoading, AGAResult }
export const PATH = { AGA, NICKNAME, LOADING, RESULT }
